import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TooltipOnHover from '../../../../components/TooltipOnHover';

var MediaToolbarButton = function MediaToolbarButton(_ref) {
  var id = _ref.id,
      actionText = _ref.actionText,
      actionColor = _ref.actionColor,
      onClick = _ref.onClick,
      children = _ref.children;
  return React.createElement(TooltipOnHover, {
    id: "file-".concat(id),
    placement: "top",
    tooltipContent: actionText
  }, React.createElement("div", {
    className: classNames('force-light-mode', 'pointer', 'margin-left-normal', "radius-normal background-white shade-30 ".concat(actionColor, "-on-hover shadow-small-on-hover"), 'transition flexbox flexbox-centered shade-10'),
    onClick: onClick,
    style: {
      width: '30px',
      height: '30px'
    }
  }, children));
};

MediaToolbarButton.propTypes = {
  id: PropTypes.string.isRequired,
  actionText: PropTypes.string.isRequired,
  actionColor: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};
export default MediaToolbarButton;